export default __webpack_public_path__ + "static/media/ic_synapse.b100121a.svg";